import { render, staticRenderFns } from "./RegionsForward.vue?vue&type=template&id=2975ed53&scoped=true"
import script from "./RegionsForward.vue?vue&type=script&lang=js"
export * from "./RegionsForward.vue?vue&type=script&lang=js"
import style0 from "./RegionsForward.vue?vue&type=style&index=0&id=2975ed53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2975ed53",
  null
  
)

export default component.exports